import styled from 'styled-components';
import { AiOutlinePlusCircle } from 'react-icons/ai';

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div``;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

export const SearchWrapper = styled.div`
  margin-top: 3rem;
  width: 35%;
`;

export const HeaderSubtitle = styled.div`
  color: ${({ theme }) => theme.colors.blue};
  font-size: 1.4rem;
  font-weight: 400;
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.colors.base[500]};
  font-size: 2.2rem;
  font-weight: 700;
  margin-right: 1.6rem;
`;

export const Content = styled.div`
  margin-top: 3rem;
`;

export const IconPlus = styled(AiOutlinePlusCircle).attrs({ size: 18 })``;
